export const locale = {
  lang: 'vn',
  data: {
    ERROR_DIALOG: {
      HEADER: 'Không thể tải trang',
      MESSAGE: 'Xin thử lại trong ít phút nữa',
      BUTTON_TEXT: 'Ok',
    },
    GUIDELINE_DOCUMENT_DIALOG: {
      CLOSE: 'ĐÓNG'
    }
  },
};
